import { Injectable, OnDestroy, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';

import { DistributionApi } from '../../../../../api/distributions/distribution.api';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { DistributionService } from '../../../../../Common/TargetingShared/services/distribution.service';
import { StatisticsReportService } from '../../../../../Common/TargetingShared/services/statistics.report.service';
import { StatisticsApiInterface } from '../../../../../Common/TargetingShared/model/statisticsReport/statistics-api.model';
import { CurrentResourceInterface } from '../../../../../Common/Basic/models/current-resource-abstract.model';
import { DistributionAccountStatisticsModel } from '../../../../../Common/TargetingShared/model/statisticsReport/distribution-account-statistics.model';

@Injectable()
export class DistributionReportService extends StatisticsReportService {

    constructor(
        protected distributionApi: DistributionApi,
        protected distributionService: DistributionService,
        protected messageService: MessageService,
        protected localizationService: LocalizationService,
    ) {
        super(
            messageService,
            localizationService
        );

        this.setupSubscription();
    }

    getResourceApi(): StatisticsApiInterface {
        return this.distributionApi;
    }

    getResourceService(): CurrentResourceInterface {
        return this.distributionService;
    }

    getAccountBenchmarks(): Observable<DistributionAccountStatisticsModel> {
        return this.distributionService.getAccountBenchmarks();
    }
}
